export enum PrecendencType {
    BillTo = 5,
    ShipTo = 7,
    Unspecified = 9,
}

export interface IShippingPreference {
    precedence: PrecendencType;
    orderGroup: OrderGroupsKey;
    billTo: string;
    shipTo: string;
    shippingMethod: string;
    lastEnabledDate: Date;
    shippingMethodDefault: string;
}

export interface IAccountShippingPreferences {
    billTo: string;
    shipTo: string;
    buyingGroup: boolean;
    defaultShippingMethods: IShippingPreference[];
}

export interface IBillToShippingPreferences
    extends IAccountShippingPreferences {
    shipToDefaultShippingMethods: IAccountShippingPreferences[];
}

export const clone = (
    obj: IAccountShippingPreferences
): IAccountShippingPreferences => {
    const cloned = {
        billTo: obj.billTo,
        shipTo: obj.shipTo,
        buyingGroup: obj.buyingGroup,
        defaultShippingMethods: obj.defaultShippingMethods.map((s) => ({
            ...s,
        })),
    };
    return cloned;
};
